module.exports = __webpack_public_path__ + "img/o-Delightful-Daycation.36100190.jpg";